import { AccountNavigationList } from '@playbooks/components/account/account-navigation-list';
import { GuestAboutCard } from '@playbooks/components/guest/guest-about-card';

const GuestSlideAbout = ({ target, onView }) => (
	<>
		<div className='border-b border-border p-4'>
			<GuestAboutCard />
		</div>
		<AccountNavigationList target={target} onView={onView} />
	</>
);

export { GuestSlideAbout };
